import { $http } from "./index";

//获取发票类型
export const invoice_select = () => {
  return $http.get("/admin/Dictionary/getInvoice");
};

//获取开票方式
export const invoicetype_select = () => {
  return $http.get("/admin/Dictionary/getInvoiceType");
};

//获取开票种类
export const invoicekind_select = () => {
  return $http.get("/admin/Dictionary/getInvoiceKind");
};
